export default __webpack_public_path__ + "static/media/ico_feature_1.779a82a4.svg";